import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import { channelApi } from './utils/api';
import './App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const RootRedirect: React.FC = () => {
  const [destination, setDestination] = useState<string | null>(null);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const channelId = localStorage.getItem('channelId');

    if (!token || !channelId) {
      setDestination('/login');
      return;
    }

    channelApi.getChannel(parseInt(channelId))
      .then(res => {
        const channel = res.data;
        setDestination(channel.youtube.enabled ? '/dashboard/youtube/queue' : '/dashboard/youtube/settings');
      })
      .catch(() => {
        setDestination('/login');
      });
  }, []);

  if (!destination) return null;
  return <Navigate to={destination} replace />;
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/dashboard/*" element={<DashboardPage />} />
            <Route path="/" element={<RootRedirect />} />
          </Routes>
        </div>
      </Router>
    </QueryClientProvider>
  );
}

export default App;